import { useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { KCL_DISPLAY_CONTACT_HISTORY, KCL_DISPLAY_SUBORDINATE_CONTACT_HISTORY } from 'features/common/acl/constants';
import { getContextUser } from 'features/views/userContext/selectors';
import ContactHistory from 'pages/ContactHistory';

import PageLayout from '../components/PageLayout';

const ContactHistoryPage = () => {
	const contextUser = useSelector(getContextUser);

	return (
		<PageLayout>
			<div className="Page-main">
				<AccessControl
					accessLevel={contextUser ? KCL_DISPLAY_SUBORDINATE_CONTACT_HISTORY : KCL_DISPLAY_CONTACT_HISTORY}
					showAccessDenied
				>
					<ContactHistory />
				</AccessControl>
			</div>
		</PageLayout>
	);
};

export default ContactHistoryPage;
